const AdvanceCommercialInformationAirApiUrls = {
  CHECKSTATUS: `${process.env.REACT_APP_USER_ACI_AIR_URL}/aci-air/acr/checkStatus`,
  UPDATESTATUS: `${process.env.REACT_APP_USER_ACI_AIR_URL}/aci-air/acr/updateStatus`,
  ARRIVALCHECKSTATUS: `${process.env.REACT_APP_USER_ACI_OCEAN_URL}/aci-ocean/arrivalmessage/checkStatus`,
  ARRIVALUPDATESTATUS: `${process.env.REACT_APP_USER_ACI_OCEAN_URL}/aci-ocean/arrivalmessage/updateStatus`

};

export default AdvanceCommercialInformationAirApiUrls
 